export default "__VITE_ASSET__CDLndUF7__"